/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=45ddefa2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__